/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".underlay-container[_ngcontent-%COMP%]{position:absolute}.underlay[_ngcontent-%COMP%]{position:fixed!important;overflow:hidden!important}.underlay[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:auto;min-width:1440px}"];
export { styles as styles };
